// @flow
import * as React from 'react';
import TimezoneSelect from 'components/TimezoneSelect';
import { getUserTimezone } from 'utils/timezones';
import Field from './Field';

const TimezoneSelectField = ({
  name,
  label,
  description,
  ...props
}: {
  name: string,
  label?: string,
  description?: string
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    customCompare={() => false}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <TimezoneSelect
        id={id}
        name={name}
        value={value || getUserTimezone()}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={updateValue}
        {...props}
      />
    )}
  />
);

export default TimezoneSelectField;
